import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StyledButton } from "./AdditionalActionsStyle";
import { Tooltip } from "@mui/material";
import { CHANGE_TIMELINE_SPEED } from "../../UserVisibleStrings";
import { setPlaybackSpeed, usePlaybackSpeed } from "../../../features/time/playbackSlice";
import { faRabbit, faRabbitRunning, faTurtle } from "@fortawesome/sharp-duotone-light-svg-icons";
import { useDispatch } from "react-redux";

/**
 * Determines the next playback speed based on the current speed.
 * @param currentSpeed - The current playback speed.
 * @returns The next playback speed.
 */
const getNextPlaybackSpeed = ( currentSpeed: number ) =>
{
    switch ( currentSpeed )
    {
        case 1:
            return 2;
        case 2:
            return 4;
        default:
            return 1;
    }
};

/**
 * Returns a FontAwesome icon based on the current playback speed.
 * @param playbackSpeed - The current playback speed.
 * @returns A FontAwesome icon.
 */
const getPlaybackIcon = ( playbackSpeed: number ) =>
{
    switch ( playbackSpeed )
    {
        case 1:
            return faTurtle;
        case 2:
            return faRabbit;
        case 4:
            return faRabbitRunning;
        default:
            return faTurtle; // Default to play icon
    }
};

export const PlaybackSpeedButton = () =>
{
    const playbackSpeed = usePlaybackSpeed();
    const dispatch = useDispatch();
    const handleSpeedChange = () =>
    {
        dispatch( setPlaybackSpeed( getNextPlaybackSpeed( playbackSpeed ) ) );
    };

    const playbackIcon = getPlaybackIcon( playbackSpeed );

    return (
        <Tooltip title = {CHANGE_TIMELINE_SPEED}>
            <StyledButton onClick = {handleSpeedChange}>
                <FontAwesomeIcon icon = {playbackIcon} size = "sm"/>
            </StyledButton>
        </Tooltip>
    );
};
